import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/cart.vue'
createPage(Page)